import { initSwiper } from '../../components/swiper';

const initRelatedProducts = () => {
  //determine if the recommendProducts data type is present
  const relatedProductsEL = document.querySelector('[data-related-products]');
  if (!relatedProductsEL) return;
  const productsUrl = relatedProductsEL.dataset.url;
  if (!productsUrl) return;

  //using that productsUrl, query the recommended products API
  const fetchResults = async (url) => {
    try {
      // Fetch recommendations for products
      const response = await fetch(url);
      const html = await response.text();
      relatedProductsEL.innerHTML = html;
      // Initialize Swiper after the new content is loaded
      const sliderEl = document.querySelector('[data-swiper-related-products]');
      if (sliderEl) initSwiper(sliderEl);
      if (typeof window.ReloadSmartWishlist === 'function') {
        await window.ReloadSmartWishlist();
      }
      if (typeof window.yotpoWidgetsContainer === 'object' && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        await window.yotpoWidgetsContainer.initWidgets();
      }
    } catch (err) {
      console.error('Error fetching filter results:', err);
    }
  };
  fetchResults(productsUrl);
};

export default initRelatedProducts;
